import { render } from "./individual_tooth_chart.vue?vue&type=template&id=788ce476&scoped=true"
import script from "./individual_tooth_chart.vue?vue&type=script&lang=js"
export * from "./individual_tooth_chart.vue?vue&type=script&lang=js"

import "./individual_tooth_chart.vue?vue&type=style&index=0&id=788ce476&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788ce476"]])

export default __exports__